export const COLLAPSE_DELAY = 5000;

export const TEST_ID = 'addButton';
